import barba from '@barba/core';
import commonScripts from './common';
import homePage from './pages/home-page';
import pageTransition from './components/page-transitions';
import cookieBanner from './components/cookies-popup';
import header from './components/header';
import accountArea from './components/account-area';
import basket from './components/basket';
import accountTabs from './pages/account-tabs';
import adresses from './pages/adresses';


export default function () {
	function delay(n) {
		n = n || 2000;
		return new Promise((done) => {
			setTimeout(() => {
				done();
			}, n);
		});
	}

    const getWindowHeight = () => {
        if (document) {
            const windowHeight = document.documentElement.clientHeight;
            const vh = windowHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
            const logo = document.querySelector('.preloader-text');

            logo? logo.style.opacity = 1 : false;
        }
    }

    getWindowHeight();

    window.addEventListener('resize', () => getWindowHeight())

	barba.init({
		debug: false,
		sync: true,
		transitions: [{
			async leave(data) {
				const done = this.async();
				pageTransition(true);
				window.scrollTo({
					top: 0,
					behavior: 'auto'
				});

				await delay(500);
				done();
			},
            beforeEnter(data) {
                document.body.style.overflow = 'auto';
                let namespace = data.next.namespace;
				document.body.dataset.pageName = namespace;
                let info = document.querySelector('.info-bar');
                info?info.dataset.pageName = namespace:false;
                document.querySelectorAll('.header-nav__item [data-open]').forEach(link => link.classList.remove('active'))
            },
			once(data) {
				header();
				pageTransition(false);
                accountArea();
                let namespace = data.next.namespace;
                let info = document.querySelector('.info-bar');
                info?info.dataset.pageName = namespace:false;
				commonScripts();
				cookieBanner();
                basket();
                window.onbeforeunload = function () {
                    window.scrollTo(0, 0);
                }
			},

			async after(data) {
				const done = this.async();

				pageTransition(false);
				await delay(100);
				done();
				commonScripts();
                
			},
            beforeLeave: () =>{
                document.querySelector('.mobile-menu').style.left = '-100%';
            }

		}],
		views: [
			{
				namespace: 'homePage',
                afterEnter: ()=>{
                    homePage();
                }
			},
            {
				namespace: 'account',
                afterEnter: ()=>{
                    accountTabs();
                }
			},
            {
				namespace: 'adresses',
                afterEnter: ()=>{
                    adresses();
                }
			},
            {
				namespace: 'collections-archive',
                afterEnter: ()=>{
                    collectionsSlider();
                }
			},
            {
				namespace: 'product',
                afterEnter: ()=>{
                   document.querySelector('header').classList.add('dark');
                },
                afterLeave: ()=>{
                    document.querySelector('header').classList.remove('dark');
                }
                
			}
		]
	})
}
